module.exports = __webpack_public_path__ + "img/diamond_bonus-en.a0937921.png";